import { colors } from "assets/styles/colors";
import styled from "styled-components";

export const FounderWrapper = styled.div<any>`
        position:relative;
        min-height:100vh;
        direction:${(props) => props.direction};
        width:100%;
        
    `

    
export const ReadMoreButton = styled.button`
border: 1px dashed ${colors.primary};
font-size: 15px;
text-decoration: none;
cursor: pointer;
padding: 10px 30px;
background: #cda55621;
border-radius: 20px;
box-shadow: 10px 10px 10px #cda55621;
`